import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "src/environments/environment";
import { map, shareReplay } from "rxjs/operators";
import { CompetencyTemplate } from "../models/competencyTemplate";
import { Dictionary } from "lodash";
import * as _ from "lodash";

@Injectable({
  providedIn: "root"
})
export class CompetencyTemplateService {

    private createHeader() {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          })
        };
        return httpOptions;
      }
         
    constructor(private httpClient: HttpClient) {}

    getCompetencyTemplatesGrouped() : Observable<Dictionary<CompetencyTemplate[]>> {
        return this.httpClient.get<CompetencyTemplate[]>(`${environment.ApiEndpoint}/Competency/GetCompetenciesTemplate`, this.createHeader())
        .pipe(
            map((data) => 
            {            
               return _.groupBy(data, type => { return type.Domain })
            }),
            shareReplay()
        )
    }

    getCompetencyTemplates() : Observable<CompetencyTemplate[]> {
      return this.httpClient.get<CompetencyTemplate[]>(`${environment.ApiEndpoint}/Competency/GetCompetenciesTemplate`, this.createHeader())
      .pipe(
          map((data) => {return data}),
          shareReplay()
      )
  }
}